import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadSuccess } from "./assetClassParametersActions";
import * as request from "utility/request";
import { AssetClassParameter } from "types/AssetClassParameter";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadAssetClassParameters = (reportControlId: string, reportDate: string) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load());

    try {
      const res = await request.getResponseJson<AssetClassParameter[]>(
        `${apiUrl}/api/assetclassparameters?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess(res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(error));
    }
  };
};
